import Container from '@/components/base/Container';
import ClosingLink from '@/components/base/ClosingLink';

export default function AboutClosing() {
  return (
    <section aria-labelledby="about-closing" className="bg-white pb-12 pt-16 md:pb-16 md:pt-20">
      <Container>
        <div className="mx-auto grid max-w-[1200px] grid-cols-1 items-center gap-10 border-t border-[#E6E6E6] pt-12 md:pt-16 lg:grid-cols-12 lg:gap-x-14">
          <div className="order-2 lg:order-1 lg:col-span-6">
            <div className="aspect-[4/3] w-full overflow-hidden rounded-lg bg-[#F2F2F0] lg:aspect-auto lg:h-[400px]">
              <img
                src="https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_about-closing.webp"
                alt="Community manager listening to residents in a residential courtyard"
                title="People-first community management - COMMON Property Management"
                className="h-full w-full object-cover object-center"
              />
            </div>
          </div>
          <div className="order-1 lg:order-2 lg:col-span-6">
            <p className="text-[12px] font-medium uppercase tracking-[0.12em] text-[#7A7A7A]">COMMON / PEOPLE</p>
            <h2 id="about-closing" className="mt-5 font-heading text-[30px] font-semibold leading-[1.15] tracking-[-0.01em] text-[#222222] md:text-[36px] lg:text-[42px]">
              Care starts with people.
            </h2>
            <p className="mt-5 max-w-[440px] text-[16px] leading-[1.6] text-[#5F5F5F]">
              Good community management begins with listening, clear communication, and consistent follow-through.
            </p>
            <div className="mt-8">
              <ClosingLink to="/contact" label="Get in Touch" />
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}